import { setPage } from '@/store/beneficiary-list-filters/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'
import { Pagination } from '@repo/ui/pagination'

export function BeneficiaryListPagination() {
  const dispatch = useStoreDispatch()
  const { page, maxPage } = useStoreState((state) => state.beneficiaryList.pagination)
  const handlePageChange = (page: number) => dispatch(setPage(page))
  return maxPage > 1 && <Pagination page={page} count={maxPage} onChange={handlePageChange} />
}
